export default "__VITE_ASSET__2D0FSbkj__"